module.exports = __webpack_public_path__ + "img/ic_live_item1.70a65b84.png";